import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PpbSharedModule } from 'projects/ppb-shared-library/src/lib/ppb-shared.module';
import { IconModule } from '@psei/ng/icon';
import { EventToolsModule } from '@psei/ng/tools/event-tools';
import { PpbShareModule } from '../shared/ppb-share.module';
import { PpbAccountRegistrationComponent } from './ppb-account-registration.component';
import { PseiNgCustomModule } from '../../../../projects/ppb-shared-library/src/lib/psei-ng-custom.module';


@NgModule({
  declarations: [PpbAccountRegistrationComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PpbShareModule,
        PpbSharedModule,
        FlexModule,
        RouterModule,
        IconModule,
        EventToolsModule,
        PseiNgCustomModule
    ]
})
export class PpbAccountRegistrationModule { }
